import React from 'react'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  dots: {
    display: 'inline-flex',
    gap: 4,
    alignItems: 'center',
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: theme.textMuted,
    opacity: 0.2,
    animation: '$pulse 1s infinite ease-in-out',
    '&:nth-child(2)': { animationDelay: '.15s' },
    '&:nth-child(3)': { animationDelay: '.3s' },
  },
  '@keyframes pulse': {
    '0%, 80%, 100%': { transform: 'scale(0.6)', opacity: 0.2 },
    '40%': { transform: 'scale(1)', opacity: 1 },
  },
  // eslint-disable-next-line mui-unused-classes/unused-classes
  '@media (prefers-reduced-motion: reduce)': {
    dot: { animation: 'none', opacity: 0.6 },
  },
}))

export default function DotsLoader() {
  const classes = useStyles()

  return (
    <div className={classes.dots}>
      <span className={classes.dot}></span>
      <span className={classes.dot}></span>
      <span className={classes.dot}></span>
    </div>
  )
}
